import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AdminGuard } from '../../guards/adminguard/admin-guard.guard';
import { AuthGuard } from '../../guards/authguard/auth-guard';
import { featureActivatedGuard } from '../../guards/feature-activated/feature-activated.guard';
import { SharedModule } from '../../shared/shared.module';
import { PdfDocumentBuilderComponent } from './components/pdf-document-builder/pdf-document-builder.component';

const routes: Routes = [
  {
    path: '',
    component: PdfDocumentBuilderComponent,
    canActivate: [AuthGuard, AdminGuard, featureActivatedGuard],
    data: {
      featureId: 'pdf-document-builder',
      minimumGungBaseVersion: '1.0.0'
    }
  }
];

@NgModule({
  declarations: [PdfDocumentBuilderComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      extend: true
    }),
    RouterModule.forChild(routes)
  ]
})
export class PdfDocumentBuilderModule {}
